module.exports = __webpack_public_path__ + "img/trash_red.af62ef74.svg";